// PROVISORIO: página de smoke test para verificar que el hook useMediaPipePose
// se conecta a la cámara y emite los 33 keypoints por frame.
// Eliminar cuando esté listo el componente smart SesionCamara.

import { useRef } from "react";
import { useMediaPipePose } from "@/lib/pose/useMediaPipePose";

export function TestPose() {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const { isLoading, error } = useMediaPipePose({
    videoRef,
    enabled: true,
    onPose: (pose) => {
      console.log("[TestPose] keypoints (33)", pose.keypoints);
    },
  });

  const status = error
    ? `Error: ${error}`
    : isLoading
      ? "Cargando..."
      : "Detectando. Abrí DevTools → Console.";

  return (
    <div className="min-h-screen bg-neutral-950 p-6 text-neutral-100 font-mono">
      <h1 className="text-xl mb-2">Test Pose — MediaPipe smoke test</h1>
      <p className="mb-1">
        Estado:{" "}
        <span className={error ? "text-red-400" : "text-emerald-400"}>
          {status}
        </span>
      </p>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        className="w-full max-w-[640px] aspect-[4/3] bg-black border border-neutral-800"
      />
      <p className="mt-3 text-xs opacity-70 max-w-[640px]">
        Página provisoria. Loguea los 33 keypoints por frame en la consola.
        Va a desaparecer cuando se conecte el componente smart SesionCamara.
      </p>
    </div>
  );
}
